<template>
  <div class="step step-one">
    <h2 class="step__title">User information</h2>
    <p class="step__description">Please fill in the data required to create a profile.</p>
    <UIInputText name="name" label="Name" placeholder="Name" />
    <UIInputText name="email" label="E-mail" :disabled="Boolean(route.query.email)" type="email" placeholder="E-mail" />
    <UIDropdown
      label="Country of residence"
      placeholder="Country of residence"
      :loading="isLoading"
      value-key="id"
      label-key="name"
      name="country"
      :items="countries"
    />
    <UIPhone name="phone" label="Phone number" placeholder="Phone number" />
    <UIButton id="step-one-next" @click="emit('next')">Next</UIButton>
  </div>
</template>

<script setup lang="ts">
const { data: countries, isLoading } = useCountries()

const emit = defineEmits<{
  (e: 'next'): void
}>()

const route = useRoute()
</script>

<style scoped lang="scss">
@import '@/styles/mixins.scss';

@include questionnaireStep();
</style>
